
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

import { sharedState } from '../state';
import { getFieldNameFromVModelProperty } from '../util/component_util';

@Component({
    components: { ValidationProvider },
})
export default class EmailField extends Vue {
    @Prop(String) name!: string;
    @Prop(String) readonly value!: string;
    @Prop(Number) readonly maxlength!: number;
    @Prop(Boolean) readonly readonly!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly disabled!: string;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly hideLabel!: boolean;
    @Prop(Number) readonly width!: number;

    shared = sharedState;
    local = {
        value: undefined as string | undefined,
    };

    async mounted() {
        await this.modelValueChange(this.value);
    }

    @Watch('value')
    async modelValueChange(newValue: string) {
        this.local.value = newValue;
    }

    @Watch('local.value')
    async inputValueChange(newValue: string) {
        this.$emit('input', newValue);
    }

    getFieldLabel(): string {
        if (this.hideLabel) {
            return '';
        } else {
            return this.$t(this.getFieldName() ? 'field.' + this.getFieldName() : '').toString();
        }
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }
}
